import { ApiUser } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const userColumns: Column<ApiUser>[] = [
    { name: 'first_name', label: 'Vorname' },
    { name: 'last_name', label: 'Nachname' },
    { name: 'email', label: 'Email' },
    {
        name: 'last_login_time',
        label: 'Letzter Login',
        renderCell: ({ rowData }) =>
            rowData.last_login_time ?? (rowData.is_activated ? 'Noch nicht eingeloggt' : 'Nicht aktiviert'),
    },
];
